module.exports = __webpack_public_path__ + "static/team-photo-marathon-142afc10e31eb2d2745e6b59a12e7e10.jpg";